import {
  GET_TIMEFRAMES_REQUEST,
  GET_TIMEFRAMES_SUCCESS,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: [],
    error: false,
  };
};

const initialState = getInitialState();

const timeframes = (state = initialState, action) => {
  const types = {
    [GET_TIMEFRAMES_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_TIMEFRAMES_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.timeframes,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default timeframes;
